import DataNotFound from '@/components/ui/not-found/data-not-found';
import ServerlessGPUPlaygroundBlueprintLLM from '@/features/blueprint/playground/llm';
import { TypeBlueprint } from '@/features/blueprint/type';
import ViewCredit from '@/pages/setting/payment/view-credit';
import PATH_PAGE from '@/router/path';
import { RouteParams } from '@/router/type';
import { useGetServerlessProjectById } from '@/service/serverless-gpu/hook';
import { useParams } from 'react-router-dom';

const ServerlessGPUPlaygroundBlueprint = () => {
  const { projectId, workspaceId } = useParams<RouteParams>();
  const { data: dataProject } = useGetServerlessProjectById({
    project_id: projectId!,
  });
  const isBlueprint =
    dataProject?.project?.project_name?.includes('[Blueprint]');
  const typeBlueprint = dataProject?.project?.project_name
    ?.split('[')[2]
    ?.split(']')[0];

  const Render = () => {
    if (!isBlueprint) {
      return (
        <DataNotFound
          goBackHref={
            PATH_PAGE.dashboard.serverlessGPU.byId(workspaceId!, projectId!)
              .playground
          }
        />
      );
    }

    if (typeBlueprint === TypeBlueprint.LLM) {
      return <ServerlessGPUPlaygroundBlueprintLLM />;
    } else {
      return <div></div>;
    }
  };

  return (
    <>
      <Render />
      <div className='container'>
        <div className="mt-8 border-t pt-8">
          <ViewCredit isShowPaymentLink={true} />
        </div>
      </div>
    </>
  );
};

export default ServerlessGPUPlaygroundBlueprint;
